import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Toggle from 'react-toggle';
import isEmpty from 'lodash/isEmpty';
import { RowDivision, DivisionLabel } from '../shared/styled-components';
import styles from '../shared/styles';
import { canUserAccessFeature } from '../../../../helpers/userinfoHelper';

class BundleOtherSettings extends Component {

  render() {
    const {
      onChange,
      enableFaqOnLandingPage,
      enableRatings,
      disableSignup,
    } = this.props;

    const settings = [
      {
        id: 'enableFaqOnLandingPage',
        key: 'enableFaqOnLandingPage',
        value: enableFaqOnLandingPage,
        title: 
          <span>
            {'Show standard FAQs on landing page (See example '}
            <a style={{ textDecoration: 'underline' }} 
              href="https://mysoundwise.com/soundcasts/1604540772115s" target="_blank">
              here
            </a>
            {')'}
          </span>,
        disabled: false,
        showWhen: true,
      },
      {
        id: 'enableRatings',
        key: 'enableRatings',
        value: enableRatings,
        title: 'Enable ratings',
        showWhen: true,
      },
      {
        id: 'disableSignup',
        key: 'disableSignup',
        value: disableSignup,
        title: 'Disable non-payment signup',
        showWhen: canUserAccessFeature('NON_PAYMENT_ACCESS_LINK'),
      },
    ].filter(setting => setting.showWhen);

    if (isEmpty(settings)) {
      return null;
    }

    return (
      <RowDivision className="row">
        <div className="col-lg-9 col-md-9 col-sm-12 col-xs-12">
          <DivisionLabel>Other Settings</DivisionLabel>
          <SettingsItem>
            {settings.map((setting, index) => {
              return (
                <div className="settings" key={`other-settings-${index}`}>
                  <Toggle
                    className="toggle-green"
                    id={`${setting.id}-status`}
                    aria-labelledby={`${setting.id}-label`}
                    checked={setting.value}
                    onChange={() => {
                      onChange(setting.key, !setting.value);
                    }}
                  />
                  <span id={`${setting.id}-label`} style={styles.toggleStatusLabel}>
                    {setting.title}
                  </span>
                </div>
              );
            })}
          </SettingsItem>
        </div>
      </RowDivision>
    );
  }
}

const SettingsItem = styled.div`
  .settings {
    display: flex;
    align-items: flex-start;
    padding-bottom: 10px;

    &:last-child {
      padding-bottom: 0;
    }
  }
`;

BundleOtherSettings.propTypes = {
  enableFaqOnLandingPage: PropTypes.bool,
  enableRatings: PropTypes.bool,
  disableSignup: PropTypes.bool,
  onChange: PropTypes.func,
};

BundleOtherSettings.defaultProps = {
  soundcastId: '',
  enableFaqOnLandingPage: true,
  enableRatings: true,
  disableSignup: false,
  onChange: () => {},
};

export default BundleOtherSettings;
